module.exports = __webpack_public_path__ + "img/teamtip_neue_saison-de-600x200.115b030d.png";